import React from 'react';
import Spinner from 'sushiweb/Spinner/Spinner';

const Button = ({
  title,
  buttonKey,
  onClick,
  type = 'primary',
  disabled,
  className,
  size = 'medium',
  visibility = true,
  loading = false,
}) => {
  if (!visibility) return null;

  if (type === 'link') {
    return (
      <button
        disabled={disabled || loading}
        key={buttonKey}
        className={`tw-text-base-green tw-bg-white tw-rounded-xl tw-border-none tw-p-0 tw-m-0 tw-cursor-pointer tw-transition-all tw-duration-200 tw-ease-in-out tw-leading-none ${className}`}
        onClick={onClick}
      >
        {!loading ? (
          <span className='tw-px-5 tw-py-3 tw-whitespace-nowrap'>{title}</span>
        ) : (
          <Spinner color={'#318616'} size='small' />
        )}
      </button>
    );
  }

  if (type === 'secondary') {
    return (
      <button
        disabled={disabled || loading}
        key={buttonKey}
        className={`tw-bg-white tw-rounded-xl tw-border tw-border-solid tw-border-white tw-relative tw-flex ${
          loading || disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'
        } tw-group tw-transition-all tw-duration-200 tw-ease-in-out hover:tw-bg-grey-200/50 ${className}`}
        onClick={onClick}
      >
        <span
          className={`tw-text-base-green  ${
            size === 'small' ? 'tw-px-1 tw-py-[6px]' : 'tw-px-5 tw-py-3'
          } tw-leading-none tw-font-medium tw-whitespace-nowrap tw-w-full`}
        >
          {!loading ? title : <Spinner color={'#318616'} size='small' />}
        </span>
      </button>
    );
  }

  if (type === 'primary' || type === '') {
    return (
      <button
        disabled={disabled || loading}
        key={buttonKey}
        className={`tw-rounded-xl tw-border tw-border-solid tw-relative tw-flex ${
          loading || disabled
            ? 'tw-cursor-not-allowed tw-bg-grey-200 tw-border-grey-300  tw-duration-200'
            : 'tw-cursor-pointer tw-bg-base-green/95 tw-border-green-600  tw-duration-1000'
        } tw-group tw-transition-all tw-ease-in-out tw-shadow-sm ${className}`}
        onClick={onClick}
      >
        <div
          className={`tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-none tw-border-y-2 tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-white tw-opacity-20 tw-rounded-xl ${
            disabled ? 'tw-bg-grey-500' : ''
          }`}
        />
        <div
          className={`tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-h-full tw-w-full tw-bg-gradient-to-b tw-transition-all tw-duration-1000 tw-ease-in-out tw-rounded-xl ${
            disabled
              ? 'tw-duration-200'
              : ' tw-from-green-500/50 group-hover:tw-from-green-400/50 tw-via-green-500/40 tw-to-base-green '
          }`}
        />

        <span
          className={`tw-text-white ${
            size === 'small' ? 'tw-px-1 tw-py-[6px]' : 'tw-px-5 tw-py-3'
          } ${
            size === 'large' ? '!tw-px-4 !tw-py-[12px]' : 'tw-px-5 tw-py-3'
          } tw-leading-none tw-font-medium tw-z-0 tw-whitespace-nowrap tw-w-full`}
        >
          {!loading ? title : <Spinner color={'white'} size='small' />}
        </span>
      </button>
    );
  }

  if (type === 'outline') {
    return (
      <button
        disabled={disabled || loading}
        key={buttonKey}
        style={{
          background: 'transparent',
        }}
        className={`tw-rounded-xl tw-border tw-border-solid tw-relative tw-flex ${
          loading || disabled
            ? 'tw-cursor-not-allowed tw-bg-grey-400 tw-border-grey-300  tw-duration-200'
            : 'tw-cursor-pointer tw-border-green-600 tw-duration-1000'
        } tw-group tw-transition-all tw-ease-in-out tw-shadow-sm ${className}`}
        onClick={onClick}
      >
        <div
          className={`tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-none tw-border-y-2 tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-white tw-opacity-20 tw-rounded-xl ${
            disabled ? 'tw-bg-grey-500' : ''
          }`}
        />
        <div
          className={`tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-h-full tw-w-full tw-bg-gradient-to-b tw-transition-all tw-duration-1000 tw-ease-in-out tw-rounded-xl ${
            disabled ? 'tw-duration-200' : '  '
          }`}
        />

        <span
          className={`tw-text-base-green  ${
            size === 'small' ? 'tw-px-1 tw-py-[6px]' : 'tw-px-5 tw-py-3'
          } tw-leading-none tw-font-medium tw-whitespace-nowrap tw-w-full`}
        >
          {!loading ? title : <Spinner color={'white'} size='small' />}
        </span>
      </button>
    );
  }

  if (type === 'icon') {
    return (
      <button
        disabled={disabled}
        key={buttonKey}
        className={`tw-bg-white tw-rounded-lg tw-aspect-square tw-border tw-border-solid tw-border-white tw-relative tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all tw-duration-200 tw-ease-in-out tw-p-[2px] hover:tw-scale-105 ${className}`}
        onClick={onClick}
      >
        {title}
      </button>
    );
  }
};

export default Button;
